import { HStack } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { primitive } from 'styles/constants';

export const OrderEtaContainer = HStack.withConfig({
  alignItems: 'center',
  backgroundColor: primitive.$blackOpacity4,
  p: '$1',
  borderRadius: primitive.$borderRadius,
  maxHeight: '$10',
  justifyContent: 'center',
});

export const OrderEtaDescription = withTypography({ ml: '$2' });
